import { RootState } from '../../store';

/**
 * Passes an ID to the selector to fetch an item by ID
 */
export const selectItemById = (_: RootState, itemId: string) => itemId;